
import { onMounted, ref } from "vue";
import moment from "moment";
import "moment-timezone";
import { useRafFn } from "@vueuse/core";

export default {
  props: {
    timestamp: Number
  },
  setup(props: any) {
    const value = ref<string>();

    onMounted(() => {
      useRafFn(
        () => {
          const { timestamp } = props as {
            timestamp: number | null;
          };

          const duration = moment.duration(
              timestamp ? moment().unix() - timestamp : 0,
              "seconds"
            ),
            hours = duration.hours(),
            minutes = duration.minutes(),
            seconds = duration.seconds();

          value.value = `${hours ? `${hours}:` : ""}${
            minutes < 10 && hours ? "0" : ""
          }${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
        },
        { immediate: true }
      );
    });

    return { value };
  }
};
